export default __webpack_public_path__ + "static/media/mauricio-dj.2769b0e4.jpeg";